export default __webpack_public_path__ + "static/media/E-WEB-Goal-07.2ec0d1a2.png";